var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings01 = function SvgSettings01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "settings-01_svg2__a",
    x1: 29.13,
    x2: 174.24,
    y1: 170.87,
    y2: 25.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M6.33 35.31h95.08c2.87 13.04 14.51 22.83 28.4 22.83s25.54-9.79 28.4-22.83h35.45c3.45 0 6.24-2.8 6.24-6.24s-2.8-6.24-6.24-6.24h-35.45C155.34 9.79 143.68 0 129.81 0s-25.53 9.8-28.4 22.83H6.33C2.88 22.82.09 25.62.09 29.07s2.8 6.24 6.24 6.24m106.89-6.23v-.07c.03-9.12 7.47-16.54 16.59-16.54s16.55 7.41 16.59 16.52v.09c0 9.13-7.45 16.56-16.59 16.56s-16.57-7.42-16.59-16.55v-.02Zm80.45 135.61h-35.45c-2.87-13.03-14.53-22.83-28.4-22.83s-25.53 9.8-28.4 22.83H6.33c-3.45 0-6.24 2.8-6.24 6.24s2.8 6.24 6.24 6.24h95.08c2.87 13.04 14.51 22.83 28.4 22.83s25.54-9.79 28.4-22.83h35.45c3.45 0 6.24-2.8 6.24-6.24s-2.8-6.24-6.24-6.24Zm-63.86 22.83c-9.13 0-16.57-7.42-16.59-16.55v-.09c.03-9.12 7.47-16.54 16.59-16.54s16.55 7.41 16.59 16.52v.09c0 9.14-7.45 16.56-16.59 16.56Zm63.86-93.76H98.59c-2.87-13.04-14.51-22.83-28.4-22.83s-25.54 9.79-28.4 22.83H6.33c-3.45 0-6.24 2.8-6.24 6.24s2.8 6.24 6.24 6.24h35.45c2.87 13.03 14.53 22.83 28.4 22.83s25.53-9.8 28.4-22.83h95.08c3.45 0 6.24-2.8 6.24-6.24s-2.8-6.24-6.24-6.24ZM86.78 99.98v.07c-.03 9.12-7.47 16.54-16.59 16.54s-16.55-7.41-16.59-16.52v-.09c0-9.14 7.45-16.56 16.59-16.56s16.57 7.42 16.59 16.55v.02Z",
    style: {
      fill: "url(#settings-01_svg2__a)"
    }
  }));
};
export default SvgSettings01;